<template>
  <div>
    <h3 class="mb-3">
      <i class="fal fa-file-signature"></i>
    </h3>

    <div class="custom-control custom-switch">
      <input type="checkbox" class="custom-control-input" :id="`${uuid}-signable`" name="signable" v-model="signableValue">
      <label class="custom-control-label" :for="`${uuid}-signable`">E-signering till</label>
    </div>

    <p v-if="deadlineManagedByAlternatives" class="text-muted small mt-2">Signeringsdatum ändras per alternativ i den nya produkteditorn under Alternativ på offertens redigeringssida.</p>
    <div v-else-if="signableValue" class="input-group input-group-sm mt-2 mb-3">
      <input :key="`${signableUntilValue}-${dateInputKey}`" type="date" :min="today" class="form-control" name="signable_until" v-model="signableUntilValue">

      <div v-if="signableUntilValue" class="input-group-append">
        <button type="button" class="btn btn-primary" @click.prevent="clearSignableUntil"><i class="fa-regular fa-times" aria-hidden="true"></i></button>
      </div>
    </div>
    <div v-else>
      <input type="hidden" name="signable_until" :value="signableUntilValue">
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { v4 as uuidv4 } from "uuid";
const props = defineProps({
    signable: {
        type: Boolean,
        required: true,
    },
    signableUntil: {
        type: String,
        default: null,
    },
    deadlineManagedByAlternatives: {
        type: Boolean,
        default: false,
    },
});
const uuid = ref(uuidv4());
const signableValue = ref(props.signable);
const signableUntilValue = ref(props.signableUntil);
const dateInputKey = ref(0);
const today = computed(() => {
    return new Date().toISOString().split("T")[0];
});
function clearSignableUntil() {
    signableUntilValue.value = null;
    dateInputKey.value += 1;
}
watch(signableValue, () => {
    clearSignableUntil();
});
</script>
